import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import InventoryStock from '../pages/inventory/InventoryStock';
import InitialStock from '../pages/inventory/InitialStock';
import InventoryMovements from '../pages/inventory/InventoryMovements';
import ProtectedRouteV2 from './ProtectedRouteV2';
import InventoryAdjustmentsPage from '../pages/inventory/InventoryAdjustmentsPage';
import InventoryTransfersPage from '../pages/inventory/InventoryTransfersPage';
import InitialStockAdminPage from '../pages/inventory/InitialStockAdminPage';

const inventoryRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/inventory"
      element={
        <>
          <PageTitle title="Gestión de Stock | POS System" />
          <InventoryStock />
        </>
      }
    />

    <Route
      path="/inventory/movements"
      element={
        <>
          <PageTitle title="Movimientos de Inventario | POS System" />
          <InventoryMovements />
        </>
      }
    />

    <Route
      path="/inventory/initial"
      element={
        <>
          <PageTitle title="Existencia Inicial | POS System" />
          <InitialStock />
        </>
      }
    />

    <Route
      path="/inventory/adjustments"
      element={
        <>
          <PageTitle title="Ajuste de Inventario | POS System" />
          <InventoryAdjustmentsPage />
        </>
      }
    />

    <Route
      path="/inventory/transfers"
      element={
        <>
          <PageTitle title="Traslado de Inventario | POS System" />
          <InventoryTransfersPage />
        </>
      }
    />

    <Route
      path="/inventory/initial-stock-admin"
      element={
        <>
          <PageTitle title="Corregir Inventario Inicial | POS System" />
          <InitialStockAdminPage />
        </>
      }
    />
  </Route>
);

export default inventoryRoutes;
